import { Input, InputProps } from 'component/Input/Input'
import { Icon } from 'icon/Icon'

export function SearchInput(props: InputProps) {
  const before = <Icon name="search" />
  return <Input panel before={before} {...props} />
}
